import { DetailRowsSkeleton, FormFieldsSkeleton } from '@/components/core';
import { Card, CardContent } from '@/components/ui-kit/card';
import { Skeleton } from '@/components/ui-kit/skeleton';

const TabsSkeleton = ({ count }: { count: number }) => (
  <div className="flex gap-2 overflow-hidden">
    {Array.from({ length: count }, (_, index) => (
      <Skeleton key={index} className="h-9 w-28 shrink-0" />
    ))}
  </div>
);

/** `EmployeeProfileView` while the employee loads: the photo card, the tabs and a tab's details. */
export const EmployeeProfileSkeleton = () => (
  <div className="flex w-full flex-col gap-4" aria-busy="true">
    <Card>
      <CardContent className="flex items-center gap-4 pt-6 max-sm:flex-col max-sm:gap-3">
        <Skeleton className="size-20 shrink-0 rounded-full" />
        <div className="flex min-w-0 flex-col gap-2 max-sm:items-center">
          <Skeleton className="h-6 w-48" />
          <Skeleton className="h-4 w-64 max-w-full" />
          <Skeleton className="h-4 w-40" />
        </div>
      </CardContent>
    </Card>
    <TabsSkeleton count={3} />
    <Card>
      <CardContent className="pt-6">
        <DetailRowsSkeleton rows={4} columns={2} />
      </CardContent>
    </Card>
  </div>
);

/** `EmployeeEditTabs` while the employee (and its lookups) load: the tabs and a tab's fields. */
export const EmployeeEditSkeleton = () => (
  <div className="flex w-full flex-col gap-4" aria-busy="true">
    <TabsSkeleton count={4} />
    <Card>
      <CardContent className="flex flex-col gap-6 pt-6">
        <FormFieldsSkeleton fields={8} columns={2} />
        <Skeleton className="h-9 w-28 self-end" />
      </CardContent>
    </Card>
  </div>
);
